import Commerce from "@chec/commerce.js"


const commerce = new Commerce('pk_test_34300c16a22023ebca832f1c9fa0bf450065c0132614b');
export default commerce;